<template>
  <v-dialog
    overlay-color="black"
    overlay-opacity="0.7"
    persistent
    max-width="350"
    v-model="show"
  >
    <v-card>
      <v-card-title class="headline">Terms of Service</v-card-title>
      <v-card-text>
        <p>
          Please read and accept our Terms of Service to continue using the
          application.
        </p>
        <div class="tos-content">
          <div class="tos-scrollable">
            {{ content }}
          </div>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="$emit('accept')">
          Accept
        </v-btn>
        <v-btn text @click="$emit('decline')">
          Decline
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  model: {
    prop: "show",
    event: "update:show"
  },
  props: {
    show: { type: Boolean, required: true },
    content: { type: String, required: true }
  }
};
</script>
